"use client"

import Link from "next/link"
import { useSelection } from "@/context/selection-context"
import { Images } from "lucide-react"
import { cn } from "@/lib/utils"

export function SelectionCounter() {
  const { selectionCount } = useSelection()

  if (selectionCount === 0) return null

  return (
    <Link
      href="/selection"
      className={cn(
        "flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1.5 text-sm font-medium text-slate-900 transition-colors hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-50 dark:hover:bg-slate-700",
        "animate-in fade-in zoom-in duration-200"
      )}
    >
      <Images className="h-4 w-4" />
      <span>My Selection ({selectionCount})</span>
    </Link>
  )
}
